export default {
  api: 'https://api.dev.cx.curvo.cloud/graphql',
  agGridLicense:
    '',
  supplierPortalBaseUrl: 'https://curvolabsdev.appiancloud.com',
  entraTenantId: 'aab837d4-0ac9-4401-b1e5-6935d5dc39b7',
  entraClientId: '2a7de74f-90f5-47b4-9242-79b26c9e9431',
  entraAuthorityHost: 'https://cbjssotest.ciamlogin.com',
  useHubspot: false,
  useHeap: false,
  launchDarklyClientId:
    '642a8c3f664163131a63d713',
  planeHostUrl: 'https://dev.plane.curvo.cloud',
  broadjumpBaseUrl: 'https://portal-stage.broadjumpllc.com',
}
